import { TIME_RANGE } from './date-time-range';

export const COMPANY_NAME = 'Para Xpress Technologies Services Inc.';

export const HEADING = 'Insights';

export const DATE_RANGE = TIME_RANGE;

export const SPEND = 'Spend';

export const COMPLETED_REQUESTS_VOLUME = 'Completed requests volume';

export const ACTIVE_USERS = 'Active users';

export const ACTIVE_USERS_LAST = 'Active users';

export const AVERAGE_SPEND_PER_COMPLETE_REQUEST =
	'Average spend per complete request';

export const EMAIL_WHEN_READY_TO_DOWNLOAD =
	'You’ll receive an email when your report is ready for download. This may take a few minutes.';

export const AMOUNT_IN_THOUSANDS = 'Amount in Thousands (₱)';
